
import { useContext, useState, useEffect } from 'react';
import { getUsersByStore } from '../../hooks/User';
import { AuthContext } from '../../context/AuthContext';
import styles from './Users.module.css';
import lineTableItems from '../../assets/line_table_items.svg'
import ArrowBelow from '../../assets/arrow_below.svg'
import { formatCPF } from '../../utils/FormatUtils';

const Users = () => {
    const { user } = useContext(AuthContext);
    const [users, setUsers] = useState([]);
    const [userTableLineId, setUserTableLineId] = useState(null);

    useEffect(() => {
        if(user != null || user !== undefined) {
            fetchUsers(user.stores[0].id)
        }
    },[])

    const fetchUsers = async (storeId) => {
        try {
            const response = await getUsersByStore(storeId);
            if (response?.data?.users) {
                setUsers(response.data.users);
            } else {
                console.error("Failed to fetch stores or no stores found.");
            }
        } catch (error) {
            console.error("Error fetching stores:", error);
        }
    };

    const handleRowClick = ( user ) => {
        setUserTableLineId(user.id);
    };

    const renderStore = ( user ) => {
        if (user?.role === "MANAGER" || user?.role === "MASTER") {
            return <td>Gerencial</td>;
        } 
        return (
            <td>{user?.stores?.[0]?.name || ''}</td>
        );
    };
      
    const handleUserRole = (role) => {
        switch (role) {
            case "MASTER":
                return "Master/Admin";
            case "MANAGER":
                return "Gerente";
            case "APP_USER":
                return "Usuário de App";
            case "PANEL_USER":
                return "Usuário de Painel";
            default:
                return "";
        }
    };
    
    return (
        <div className={styles.container}>
            <div className={styles.infoLine}>
                <img src={ArrowBelow} alt="Seta para baixo" />
                <h4 className={styles.headerInfo}>Tabela de Usuários</h4>
                <img className={styles.line} src={lineTableItems} alt="Linha" />
            </div>
            <div className={styles.tableItems}>
                <table>
                    <thead>
                        <tr>
                            <th><div className={styles.scrollableHeader}>Id</div></th>
                            <th><div className={styles.scrollableHeader}>Nome</div></th>
                            <th><div className={styles.scrollableHeader}>Login/CPF</div></th>
                            <th><div className={styles.scrollableHeader}>Função</div></th>
                            <th><div className={styles.scrollableHeader}>Senha</div></th>
                            <th><div className={styles.scrollableHeader}>Telefone</div></th>
                            <th><div className={styles.scrollableHeader}>Loja</div></th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? (
                            users.map((user) => (
                                <tr 
                                    key={user.id}
                                    onClick={() => handleRowClick( user )}
                                    className={user.id === userTableLineId ? styles.selectedRow : ''}>
                                    <td>{user.id}</td>
                                    <td>{user.name}</td>
                                    <td>{formatCPF(user.username) || user.username}</td>
                                    <td>{handleUserRole(user.role)}</td>
                                    <td>**********</td>
                                    <td>{user.phone}</td>
                                    { renderStore(user) }
                                </tr>
                            ))
                        ) : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Users;